import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import createPersistedState from 'vuex-persistedstate'

import cart from '@/store/modules/cart'
import currency from '@/store/modules/currency'
import dialog from '@/store/modules/dialog'
import loading from '@/store/modules/loading'
import locale from '@/store/modules/locale'
import redirect from '@/store/modules/redirect'
import session from '@/store/modules/session'
import wishlist from '@/store/modules/wishlist'
import integrations from '@/store/modules/integrations'

const dataState = createPersistedState({
    paths: ['locale', 'session', 'dialog', 'mappings', 'order', 'integrations', 'cart'],
})

export default new Vuex.Store({
    plugins: [dataState],
    modules: {
        cart,
        currency,
        dialog,
        loading,
        locale,
        redirect,
        session,
        wishlist,
        integrations,
    },
})
